import { IHomeCountry } from '@nibtravel/shared/util/models';

/**
 * Action which is dispatched to get the countries list using products APi
 */
export class LoadCountries {
  public static readonly type = '[Countries] Fetch countries list';
  constructor(public brand: string) {}
}

/**
 * Action which is dispatched after LoadCountries is successful
 */
export class HomeCountrySelected {
  public static readonly type = '[Countries] Home country selected';
  constructor(public country: IHomeCountry) {}
}
